module.exports = __webpack_public_path__ + "static/media/4540.5314d548.jpg";